// ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
import styled from 'styled-components';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import ButtonUnstyled from '@ecp/common/src/components/unstyled/button/ButtonUnstyled';

const Container = styled(FlexBoxColumn)`
  position: relative;
  width: 100%;
  margin-top: 0;
  height: 100%;
  transition: margin-top 0.3s ease-in-out;
  background-color: #f7f7f7;

  &.down,
  &.bottom {
    margin-top: 700px;
  }
`;

const MenuButtonContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  z-index: 10;

  &::after {
    position: absolute;
    bottom: -1px;
    content: '';
    height: 2px;
    left: 0;
    right: 0;
    border-left: 1px solid ${(props) => props.theme.color.line.basic};
    border-right: 1px solid ${(props) => props.theme.color.line.basic};
    background-color: ${(props) => props.theme.color.background.basic};
  }
`;

const Menu = styled(ButtonUnstyled)`
  flex: 1;
  height: 70px;
  border: none;
  padding: 12px 0;
  background-color: transparent;
`;

const MenuWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: ${({ selected }) => (selected ? '1px solid #919191;' : 'none')};
`;

export { Container, MenuButtonContainer, Menu, MenuWrapper };


